// Shared inline-style objects for form controls and buttons, matching the
// skeleton's idiom (inline styles on --brand-* tokens, no styling library).

import type { CSSProperties } from 'react';

export const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: 'var(--brand-text, #001C3E)',
  marginBottom: 4,
};

export const inputStyle: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  padding: '7px 10px',
  borderRadius: 4,
  border: '1px solid var(--brand-border, #D6E4EE)',
  fontSize: 13,
  color: 'var(--brand-text, #001C3E)',
  background: 'var(--brand-card-bg, white)',
};

export const selectStyle: CSSProperties = {
  ...inputStyle,
  cursor: 'pointer',
};

export const textareaStyle: CSSProperties = {
  ...inputStyle,
  resize: 'vertical',
  minHeight: 90,
  fontFamily: 'inherit',
};

export const primaryButtonStyle: CSSProperties = {
  background: 'var(--brand-primary, #001C3E)',
  color: 'var(--brand-text-on-primary, white)',
  border: 'none',
  padding: '8px 16px',
  borderRadius: 4,
  fontWeight: 500,
  fontSize: 13,
  cursor: 'pointer',
};

export const secondaryButtonStyle: CSSProperties = {
  background: 'transparent',
  color: 'var(--brand-text, #001C3E)',
  border: '1px solid var(--brand-border, #D6E4EE)',
  padding: '7px 14px',
  borderRadius: 4,
  fontWeight: 500,
  fontSize: 13,
  cursor: 'pointer',
};

export const dangerTextStyle: CSSProperties = {
  background: '#FEE',
  color: '#900',
  padding: 8,
  borderRadius: 4,
  fontSize: 13,
};

export const fieldGap: CSSProperties = { marginBottom: 14 };
